<div class="row">
  <div class="col-lg-12 table-responsive">
    <form [formGroup]="monthlyPaymentForm">
      <table class="w-100 myh_val">
        <tr>
          <td class="tab-border">
            <label
              >Mortgage Payment
              <mat-icon
                *ngIf="mortgageListLength > 1"
                matSuffix
                [matTooltip]="'Monthly payment amount for the first mortgage'"
                matTooltipClass="line-break"
                [matTooltipPosition]="'right'"
                class="help-icon"
                >help_outline</mat-icon
              ></label
            >
            <h4>${{ mortgagePaymentMonthly | number: '1.0-0' }}</h4>
            <p>&nbsp;</p>
          </td>
          <td class="sign">
            <h4>+</h4>
          </td>
          <td class="tab-border">
            <label>Property Tax</label>
            <ng-container *ngIf="propertyTaxValue != 0; else zeroPropertyTaxValue">
              <h4>${{ propertyTaxValue | toNumber | number: '1.0-0' }}</h4>
            </ng-container>
            <ng-template #zeroPropertyTaxValue>
              <h4>--</h4>
            </ng-template>
            <p>Annual Tax: ${{ propertyTaxValue * 12 | toNumber | number: '1.0-0' }}</p>
          </td>
          <td class="sign">
            <h4>+</h4>
          </td>
          <td class="tab-border myH_proprate">
            <label
              >Home Insurance
              <button
                class="myHedit_btn"
                style="margin-left: 8px"
                [ngbPopover]="homeInsuranceContent"
                #homeInsurancePopover="ngbPopover"
                [popoverTitle]="homeInsuranceTitle"
                placement="bottom"
                [autoClose]="false"
              >
                &#9998;
              </button></label
            >

            <ng-container *ngIf="insuranceValue != 0; else zeroInsuranceValue">
              <h4>${{ insuranceValue | toNumber | number: '1.0-0' }}</h4>
            </ng-container>
            <ng-template #zeroInsuranceValue>
              <h4>--</h4>
            </ng-template>

            <p>Annual Insurance: ${{ insuranceValue * 12 | toNumber | number: '1.0-0' }}</p>
            <ng-template #homeInsuranceContent>
              <mat-form-field>
                <input
                  type="number"
                  min="0"
                  class="text-center"
                  floatLabel="never"
                  matInput
                  name="customHomeInsuranceValue"
                  formControlName="customHomeInsuranceValue"
                  autocomplete="off"
                  (keydown)="allowOnlyNumbers($event)"
                />
              </mat-form-field>
              <button mat-icon-button aria-label="Cancel" matTooltip="Cancel">
                <i
                  class="material-icons"
                  style="font-size: 20px; color: #60697a"
                  (click)="revertValue('customHomeInsuranceValue')"
                >
                  restart_alt
                </i>
              </button>
              <button mat-icon-button aria-label="Ok" matTooltip="Ok" (click)="saveValue('customHomeInsuranceValue')">
                <i class="material-icons" style="font-size: 20px; color: #4caf50"> done </i>
              </button>
            </ng-template>
            <ng-template #homeInsuranceTitle
              >Edit Home Insurance
              <button mat-icon-button aria-label="Ok" matTooltip="close">
                <i
                  class="material-icons"
                  style="font-size: 20px; color: #bdbdd0"
                  (click)="homeInsurancePopover.close()"
                >
                  close
                </i>
              </button></ng-template
            >
          </td>
          <td class="sign">
            <h4>+</h4>
          </td>
          <td class="tab-border myH_proprate" width="12%">
            <label
              >HOA
              <button
                class="myHedit_btn"
                style="margin-left: 8px"
                [ngbPopover]="HOAValueContent"
                #hoaValuePopover="ngbPopover"
                [popoverTitle]="HOAValueTitle"
                placement="bottom"
                [autoClose]="false"
              >
                &#9998;
              </button></label
            >

            <ng-container *ngIf="hoaFeeValue != 0; else zeroHoaFeeValue">
              <h4>{{ hoaFeeValue | currency: 'USD':'symbol':'0.0-0' }}</h4>
            </ng-container>
            <ng-template #zeroHoaFeeValue>
              <h4>--</h4>
            </ng-template>

            <p>&nbsp;</p>
            <ng-template #HOAValueContent>
              <mat-form-field>
                <input
                  type="number"
                  min="0"
                  class="text-center"
                  floatLabel="never"
                  matInput
                  name="customHoaValue"
                  formControlName="customHoaValue"
                  autocomplete="off"
                  (keydown)="allowOnlyNumbers($event)"
                />
              </mat-form-field>
              <button mat-icon-button aria-label="Cancel" matTooltip="Cancel">
                <i
                  class="material-icons"
                  style="font-size: 20px; color: #60697a"
                  (click)="revertValue('customHoaValue')"
                >
                  restart_alt
                </i>
              </button>
              <button mat-icon-button aria-label="Ok" matTooltip="Ok" (click)="saveValue('customHoaValue')">
                <i class="material-icons" style="font-size: 20px; color: #4caf50"> done </i>
              </button>
            </ng-template>
            <ng-template #HOAValueTitle
              >Edit HOA
              <button mat-icon-button aria-label="Ok" matTooltip="close">
                <i class="material-icons" style="font-size: 20px; color: #bdbdd0" (click)="hoaValuePopover.close()">
                  close
                </i>
              </button></ng-template
            >
          </td>
          <td class="sign">
            <h4>=</h4>
          </td>
          <td class="cal-balance">
            <label>Total Monthly Cost</label>
            <h4 class="mb-0">${{ totalPaymentMonthly | toNumber | number: '1.0-0' }}</h4>
            <p>&nbsp;</p>
          </td>
          <td colspan="2">&nbsp;</td>
        </tr>
        <tr>
          &nbsp;
        </tr>
        <tr>
          <td colspan="4">&nbsp;</td>
          <td colspan="3" width="" class="note-txt">
            You may be able to rent this property
            <span *ngIf="!isNegativeOrder(potentialMonthlyRent - totalPaymentMonthly)"> at positive cash flow</span>
          </td>
          <td>&nbsp;</td>
          <!-- <td class="tab-border">
            <label>Potential Monthly Rent</label>
            <h4 class="mb-1">${{ potentialMonthlyRent | toNumber | number: '1.0-0' }}</h4>
            <p class="a-analyze" (click)="openDealAnalysisSheet(pmxPropertyId)">Analyze Rental Return</p>
          </td> -->
          <td class="tab-border myH_proprate" width="12%">
            <label>
              Monthly Rent
              <button
                class="myHedit_btn"
                style="margin-left: 5px"
                [ngbPopover]="potentialMonthlyRentContent"
                #potentialMonthlyRentPopover="ngbPopover"
                [popoverTitle]="potentialMonthlyRentTitle"
                placement="bottom"
                [autoClose]="false"
              >
                &#9998;
              </button></label
            >
            <ng-container *ngIf="potentialMonthlyRent != 0; else nopotentialMonthlyRent">
              <h4>{{ potentialMonthlyRent | currency: 'USD':'symbol':'0.0-0' }}</h4>
            </ng-container>
            <ng-template #nopotentialMonthlyRent>
              <h4>--</h4>
            </ng-template>
            <!-- <p>&nbsp;</p> -->
            <ng-template #potentialMonthlyRentContent>
              <mat-form-field>
                <input
                  type="number"
                  min="0"
                  class="text-center"
                  floatLabel="never"
                  matInput
                  name="customPotentialMonthly"
                  formControlName="customPotentialMonthly"
                  autocomplete="off"
                  (keydown)="allowOnlyNumbers($event)"
                />
              </mat-form-field>
              <button mat-icon-button aria-label="Cancel" matTooltip="Cancel">
                <i
                  class="material-icons"
                  style="font-size: 20px; color: #60697a"
                  (click)="revertValue('potentialMonthlyRent')"
                >
                  restart_alt
                </i>
              </button>
              <button mat-icon-button aria-label="Ok" matTooltip="Ok" (click)="saveValue('potentialMonthlyRent')">
                <i class="material-icons" style="font-size: 20px; color: #4caf50"> done </i>
              </button>
            </ng-template>
            <ng-template #potentialMonthlyRentTitle
              >Edit Monthly Rent
              <button mat-icon-button aria-label="Ok" matTooltip="close">
                <i
                  class="material-icons"
                  style="font-size: 20px; color: #bdbdd0"
                  (click)="potentialMonthlyRentPopover.close()"
                >
                  close
                </i>
              </button></ng-template
            >
            <p class="a-analyze" (click)="openDealAnalysisSheet(pmxPropertyId)">Analyze Rental Return</p>
          </td>

          <td></td>
          <td class="tab-border">
            <label>Monthly Cash Flow</label>
            <h4 class="mb-1" *ngIf="isNegativeOrder(potentialMonthlyRent - totalPaymentMonthly)">--</h4>
            <h4 class="mb-1" *ngIf="!isNegativeOrder(potentialMonthlyRent - totalPaymentMonthly)">
              ${{ potentialMonthlyRent - totalPaymentMonthly | toNumber | number: '1.0-0' }}
            </h4>

            <p class="a-analyze" (click)="openDealAnalysisSheet(pmxPropertyId)">Analyze Rental Return</p>
          </td>
        </tr>
      </table>
    </form>
  </div>
</div>
